// Login.js
import React, { useState, useEffect } from "react";
import {
  LoginContainer,
  LoginCard,
  Title,
  TabsContainer,
  Tab,
  LogoImg,
} from "./Login.styles";
import LoginForm from "./LoginForm";
import logoImage from "../../images/logo_ylhq.png";

function Login() {
  const [activeTab, setActiveTab] = useState("login");

  // Handle tab change from URL hash
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.replace("#", "");
      if (hash === "register") {
        setActiveTab("register");
      } else if (hash === "forgot-password") {
        setActiveTab("forgot-password");
      } else {
        setActiveTab("login");
      }
    };

    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, []);

  const switchTab = (tab) => {
    setActiveTab(tab);
    window.location.hash = `#${tab}`;
  };

  return (
    <LoginContainer>
      <LoginCard>
        <LogoImg src={logoImage} alt="Yellow Letter HQ Logo" />
        <Title>Admin Dashboard</Title>

        <TabsContainer>
          <Tab
            active={activeTab === "login"}
            onClick={() => switchTab("login")}
          >
            Login
          </Tab>
          <Tab
            active={activeTab === "register"}
            onClick={() => switchTab("register")}
          >
            Sign Up
          </Tab>
        </TabsContainer>

        <LoginForm activeTab={activeTab} logoImage={logoImage} />
      </LoginCard>
    </LoginContainer>
  );
}

export default Login;
